// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Materialtransport, MaterialtransportDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateMaterialtransport(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  requestBody: MaterialtransportDaten
) => Promise<Materialtransport> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, requestBody) =>
      (await getAPI()).materialtransporte.createMaterialtransport({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        requestBody,
      }),
    [getAPI]
  );
}
